import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import useAxios from "../../../../hooks/useAxios";
import { IGetStaffs, IStaffList } from "../../../../models/employees.model";
import { RootState } from "../../../../store/rootReducer";
import { Button as AntButton, Modal, Table, TableColumnsType } from 'antd';
import Button from '../../../Button';
import { getStaffs } from "../../../../api/employees.api";
import Loader from "../../../Loader";
import ErrorResponse from "../../../ErrorResponse";
import config from '../../../../lib/config';
import Pagination from '../../../Pagination';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  scheduleIndex: number;
  onSetSchedule: (index: number, key: string, value: string) => void;
  selectHelperMode: string;
}

const SelectHelperModal: FC<IProps> = ({
  visible, setVisible, scheduleIndex, onSetSchedule, selectHelperMode
}) => {
  const { t } = useTranslation();
  const { currentCampus } = useSelector((state: RootState) => state.auth);  
  const { data: res, isLoading, error, execute } = useAxios<IGetStaffs>();
  const [page, setPage] = useState(1);

  useEffect(() => {
    execute(getStaffs({
      campusCode: currentCampus,
      authGroup: 'S'
    }));
  }, [currentCampus]);

  const columns: TableColumnsType<IStaffList> = [
    {
      title: t('campus.staff.column35'),
      dataIndex: 'memberName',
      key: 'memberName',
      align: 'center',
      sorter: (a, b) => a.memberName?.localeCompare(b.memberName),
    },
    {
      title: t('campus.staff.column36'),
      dataIndex: 'webId',
      key: 'webId',
      align: 'center',
      sorter: (a, b) => a.webId?.localeCompare(b.webId),
    },
    {
      title: '',
      dataIndex: 'memberCode',
      key: 'memberCode',
      align: 'center',
      render: (value, record) => (
        <div className="comm-btn__area justify-content-center">
          <Button
            className="btn-basic small mint"
            onClick={() => {
              if (scheduleIndex < 0) return;

              if (selectHelperMode === 'attend') {
                onSetSchedule(scheduleIndex, 'attendMemCode', value);
                onSetSchedule(scheduleIndex, 'attendMemKorName', record.memberName);
              } else {
                onSetSchedule(scheduleIndex, 'overMemCode', value);
                onSetSchedule(scheduleIndex, 'overMemKorName', record.memberName);
              }

              setVisible(false);
            }}
            text={t('common.button.select')}
          />
        </div>
      )
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('campus.shuttle.title7')}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <Table
          className='comm-table__area mt-0'
          columns={columns}
          dataSource={res?.data}
          pagination={{
            current: page,
            pageSize: config.smallPageSize,
          }}
          rowKey="busCode"
        />
        <div className='comm-bx__between'>
          <div className="common-paging center">
            <Pagination
              count={res?.data.length || 0}
              page={page}
              setPage={setPage}
            />
          </div>
        </div> 
      </Modal>
    </>
  );
}

export default SelectHelperModal;
